import scroll from "../views/scroll";

var CLASS = {
  OPEN: "open"
};

const overlay = document.createRange().createContextualFragment("<div class='js-overlay'></div>").firstElementChild;
document.body.appendChild(overlay);
var onCloseCallbacks = [];
var canBeClosedOnClick = true;

// on overlay click close it
overlay.addEventListener("click", onOverlayClicked);

function onOverlayClicked() {
  if (canBeClosedOnClick) {
    hideOverlay();
  }
}

function hideOverlay() {
  // onClose callback
  if (onCloseCallbacks.length) {
    onCloseCallbacks.forEach(function (callback) {
      callback();
    });

    // reset close callback
    onCloseCallbacks.length = 0;
  }

  overlay.classList.remove(CLASS.OPEN);

  // re-enable scroll in main container
  scroll.unlock();
}

function isOverlayOpened() {
  return overlay.classList.contains(CLASS.OPEN);
}

// use this when you need to add an overlay

export default {
  show(options) {
    options = options || {};

    // re-enable anyway to avoid missed used of disableClick
    this.enableClick();

    overlay.classList.add(CLASS.OPEN);

    // disable scroll to avoid scrolling in main contener when overlay is on
    if (options.disableScroll) {
      scroll.lock();
    }
  },

  hide: hideOverlay,

  toggle() {
    if (isOverlayOpened()) {
      this.hide();
    } else {
      this.show();
    }
  },

  isOpened: isOverlayOpened,

  onClose(callback) {
    onCloseCallbacks.push(callback);
  },

  enableClick() {
    canBeClosedOnClick = true;
  },

  disableClick() {
    canBeClosedOnClick = false;
  }
};
